// 枚举定义
export enum SystemType {
  All = 0,
  Website = 1,
  Software = 2
}

export enum NotificationType {
  Inform = 0,      // 普通通知
  Announcement = 1, // 公告
  Expiration = 2   // 授权到期
}

export enum NotificationTargetType {
  All=0, //所有
  // User = 1,        // 用户
  Department = 1,  // 部门
  Software = 2,    // 软件
  Role = 3        // 角色
}

export enum RepeatFrequency {
  None = 0,        // 不重复
  Daily = 1,       // 每天
  Weekly = 2,      // 每周
  Monthly = 3,     // 每月
  Hourly = 4,      // 每小时
  EveryLogon = 5   // 每次登录
}

export enum RuleStatus {
  Active = 0,     // 活跃
  Paused = 1,     // 暂停
  Completed = 2,  // 已完成
  Error = 3       // 错误
}

// 实体接口 - 根据后端实体调整
export interface Notification {
  id: number;
  title: string;
  content: string;
  expirationTitle?: string;  // 新增：已到期通知标题
  expirationContent?: string; // 新增：已到期通知内容
  type: NotificationType;
  systemType: SystemType;
  ruleId?: number;
  createdAt: string;
  rules?: NotificationRule[];
  byUsers?: NotificationByUser[];
}

export interface NotificationByUser {
  id: number;
  notificationId: number;
  title: string;           // 从后端直接存储
  content: string;         // 从后端直接存储
  userId?: number;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
  notification?: Notification;
  user?: any;
}

export interface NotificationTarget {
  id: number;
  notificationRuleId?: number;
  targetType: NotificationTargetType;
  userId?: number;
  departmentId?: number;
  softwareId?: number;
  roleId?: number;
}

export interface NotificationRule {
  id: number;
  name: string;
  description: string;
  notificationId: number;
  customCron?: string;
  startDate: string;
  endDate?: string;
  specificTime?: string;  // 改为可选的字符串格式
  hoursBefore: number;    // 改为必填，移除 daysBefore
  frequency: RepeatFrequency;
  interval: number;
  isEnabled: boolean;
  maxGenerations: number;
  generatedCount: number;
  status: RuleStatus;
  lastExecutedAt?: string;
  nextExecuteAt?: string;
  lastError?: string;
  errorCount: number;
  maxErrorCount: number;
  createdAt: string;
  lastGeneratedAt?: string;
  targets?: NotificationTarget[];
  notification?: Notification;
}

// 根据后端返回结构调整
export interface UserNotificationView {
  id: number;
  notificationId?: number;
  title: string;
  content: string;
  type: NotificationType;
  systemType: SystemType;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export interface AdminNotificationView {
  id: number;
  title: string;
  content: string;
  type: NotificationType;
  createdAt: string;
  rulesCount: number;
  totalTargetsCount: number;  // 对应后端的 ByUsers 数量
  readCount: number;
  systemType: SystemType
}

export interface RuleView {
  id: number;
  name: string;
  notificationId: number;
  description: string;
  frequency: RepeatFrequency;
  interval: number;
  customCron?: string;
  startDate: string;
  endDate?: string;
  specificTime?: string;
  hoursBefore: number;
  isEnabled: boolean;
  status: RuleStatus;
  maxGenerations: number;
  generatedCount: number;
  lastGeneratedAt?: string;
  lastExecutedAt?: string;
  nextExecuteAt?: string;
  errorCount: number;
  maxErrorCount: number;
  lastError?: string;
  createdAt: string;
  targetsCount: number;
  systemType:SystemType;
  targetType:NotificationTargetType;
  targetIds?:number[];
  companyId:number;
}

export interface ActiveRuleView {
  id: number;
  name: string;
  frequency: RepeatFrequency;
  nextExecuteAt?: string;
  lastExecutedAt?: string;
  generatedCount: number;
  maxGenerations: number;
}

// 统计接口 - 根据后端返回结构调整
export interface NotificationStats {
  totalCount: number;
  unreadCount: number;
  todayCount: number;
  // 移除 activeCount 和 expiredCount，后端未返回
}

export interface RuleStats {
  totalRules: number;
  enabledRules: number;
  disabledRules: number;
  errorRules: number;
  todayExecutedRules: number;
  totalExecutions: number;
}

export interface StatsResponse {
  notificationStats: NotificationStats;
  ruleStats: RuleStats;
}

// DTO 接口 - 根据后端 DTO 调整
export interface CreateNotificationParams {
  title: string;
  content: string;
  type: NotificationType;
  expirationTitle?: string;  // 新增
  expirationContent?: string; // 新增
}

export interface UpdateNotificationParams {
  title?: string;
  content?: string;
  type?: NotificationType;
  expirationTitle?: string;  // 新增
  expirationContent?: string; // 新增
}

export interface CreateRuleParams {
  name: string;
  notificationId:number,
  description?: string;
  frequency: RepeatFrequency;
  interval?: number;
  customCron?: string;
  startDate: string;
  endDate?: string;
  specificTime?: string;  // 改为字符串格式
  hoursBefore: number;    // 改为必填
  isEnabled?: boolean;
  maxGenerations?: number;
  systemType:SystemType;
  targetType: NotificationTargetType;
  targetIds: number[];
  companyId:number;
}

export interface BatchReadParams {
  ids: number[];
}

// 查询参数接口 - 根据后端调整
export interface NotificationQueryParams {
  skip?: number;
  take?: number;
  unreadOnly?: boolean;
  userId?: number;  // 后端需要
}

// 响应接口
export interface NotificationListResponse {
  list: UserNotificationView[];
  total: number;
  skip: number;
  take: number;
}

export interface AdminNotificationListResponse {
  list: AdminNotificationView[];
  total: number;
  skip: number;
  take: number;
}

export interface RuleListResponse {
  list: RuleView[];
}

// 操作结果接口
export interface BatchOperationResult {
  updatedCount: number;
}

export interface RuleExecutionResult {
  createdCount: number;
}

export interface RuleCreateResult {
  ruleId: number;
  targetsCount: number;
}